import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LayoutDashboard, Building2, RefreshCw, ShieldCheck, Boxes, ListChecks, ScrollText, LogOut, Settings } from "lucide-react";
import clsx from "clsx";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, exact: true, testid: "nav-dashboard" },
  { to: "/companies", label: "Società", icon: Building2, testid: "nav-companies" },
  { to: "/sync-runs", label: "Esecuzioni Sync", icon: RefreshCw, testid: "nav-sync-runs" },
  { to: "/verifactu", label: "Sync VeriFactu", icon: ShieldCheck, testid: "nav-verifactu" },
  { to: "/holded", label: "Sync Holded", icon: Boxes, testid: "nav-holded" },
  { to: "/review", label: "Coda Revisione", icon: ListChecks, testid: "nav-review" },
  { to: "/audit", label: "Audit Log", icon: ScrollText, testid: "nav-audit" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-app text-ink">
      <aside className="w-60 bg-surface border-r border-border-default flex flex-col">
        <div className="px-5 py-5 border-b border-border-default">
          <div className="font-display text-lg font-bold tracking-tight">Bridge ZF</div>
          <div className="text-xs text-ink-muted mt-0.5">Zoho → FacturaDirecta</div>
        </div>
        <nav className="flex-1 py-3 space-y-0.5">
          {NAV.map(({ to, label, icon: Icon, exact, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={exact}
              data-testid={testid}
              className={({ isActive }) =>
                clsx(
                  "flex items-center gap-2.5 mx-2 px-3 py-2 rounded-md text-sm font-medium transition-colors",
                  isActive ? "bg-surface-hover text-ink" : "text-ink-muted hover:bg-surface-hover hover:text-ink"
                )
              }
            >
              <Icon size={16} strokeWidth={2} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border-default p-3 space-y-2">
          <div className="px-2">
            <div className="text-xs text-ink-muted">Connesso come</div>
            <div className="text-sm font-medium truncate" data-testid="current-user-email">{user?.email}</div>
          </div>
          <button
            onClick={async () => { await logout(); nav("/login"); }}
            className="flex items-center gap-2 w-full px-3 py-2 rounded-md text-sm text-ink-muted hover:bg-surface-hover hover:text-ink"
            data-testid="btn-logout"
          >
            <LogOut size={16} /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-[1400px] mx-auto px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
